/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'underscore',
	'../../lib/@waca/core-client/js/core-client/ui/core/View',
	'react',
	'react-dom',
	'./internal/DataSourcePanelComponent',
	'../glassControllers/AddSourceActionHandler'
], function (
	_,
	View,
	React,
	ReactDOM,
	DataSourcePanelComponent,
	AddSourceActionHandler
) {


	/**
	 * @classdesc  Creates a topBottom dialog
	 *
	 * @public
	 * @callback callback
	 * @param {object} options.eventHandler - Event handler
	 * @param {object} [options.state] - If you want to pass the existing top/bottom state
	 * @param {Array} [options.contextColumns] - An array of columns to search from for attribute column, if omitted this field is not shown
	 * @param {boolean} [options.allowRankColumn] - Puts a checkbox on the dialog to add rank column on creation.
	 * @param {callback} [options.onSearch] - on search call back
	 */
	class DataSourcePanel extends View {

		constructor(...args) {
			super(...args);

			const options = args[0];

			this.dashboardView = options.glassContext.appController.getCurrentContentView();

			// Indicate that this view must be reloaded when the dashboard view is reloaded
			// because we depend on the datasource service
			this.dashboardView.addReloadableObject(this.viewId, this);

			this.initialize();
		}

		initialize() {
			this.dashboardApi = this.dashboardView.getDashboardApi();
		}

		remove() {
			if (this.$el) {
				ReactDOM.unmountComponentAtNode(this.$el[0]);
			}

			return super.remove();
		}

		reload() {
			ReactDOM.unmountComponentAtNode(this.$el[0]);
			this.initialize();
			this.render();
		}

		render() {
			this.$el.addClass('datasetPanel');

			this.reactComponents = ReactDOM.render(
				<DataSourcePanelComponent
					dashboardApi={this.dashboardApi}
					transientState={{
						get: key => this.dashboardView.getTransientState(key),
						set: (key, value) => this.dashboardView.setTransientState(key, value)
					}}
					actionHandlers={{
						addDataSource: () => this.onAddDataSource()
					}}
				/>,
				this.$el[0]
			);

			return this;
		}


		onAddDataSource() {
			new AddSourceActionHandler({ 'dashboardApi': this.dashboardApi }).execute();
		}
	}

	return DataSourcePanel;
});
